import React, { useState, useEffect } from 'react';
import { Button, Box, Typography } from '@mui/material';
import ModalWrapper from '../Modal/modalWrapper/aiGeneratorSaveTestCasesModal'; // Adjust path as needed
import FolderDrawerTreeView from '../FolderDrawerTreeView';
import { fetchModulesTreeViewData } from '../../utils/api';

function SaveTestCaseModal({ open, onClose, onSave }) {
  const [selectedModuleId, setSelectedModuleId] = useState(null);
  const [treeData, setTreeData] = useState([]);
  const [selected, setSelected] = useState([]);

  // Reset selected module when modal is closed
  useEffect(() => {
    if (!open) {
      setSelectedModuleId(null); // Reset the selected module when modal is closed
    }
  }, [open]);

  useEffect(() => {
    (async ()=>{
      const data = await fetchModulesTreeViewData();
      if(data?.length) {
        setTreeData([...data]);
      }
    })()
  }, [])

  const handleModuleSelect = (moduleId) => {
    setSelectedModuleId(moduleId); // Store selected module
  };

  const handleSaveClick = () => {
    if (selectedModuleId) {
      onSave(selectedModuleId); // Pass selected module ID back to save handler
      onClose(); // Close modal after saving
    }
  };

  const buttons = [
    {
      label: 'Cancel',
      onClick: onClose,
      variant: 'outline',
      className: 'primary',
    },
    {
      label: 'Save',
      onClick: handleSaveClick,
      variant: 'primary',
      className: 'white bg-blue600',
      disabled: selectedModuleId === null, // Disabled if no module is selected
    },
  ];

  return (
    <ModalWrapper open={open} onClose={onClose} title="Add to Module" buttons={buttons}>
      <FolderDrawerTreeView 
            data={treeData} 
            onLeafNodeClick={handleModuleSelect}
            hideHeader={true}
            showSearch={true}
            smallView={true}
            selected={selected}
            setSelected={setSelected}
          />
    </ModalWrapper>
  );
}

export default SaveTestCaseModal;

